module.exports = __webpack_public_path__ + "static/media/renewal_bell_target.33927dcc.png";